// src/routes/DashboardRoutes.js
import React from "react";
import { Route } from "react-router-dom";
import PgHomeEntry from "../dashboard/pghome";
import ResponsiveDrawer from "../dashboard/drawer";
// import IndentEntry from "../masterpages/Indent/IndentEntry";
// import IndentEdit from "../masterpages/Indent/IndentEdit";
// import PoPageEntry from "../masterpages/PO/poentry";
// import POList from "../masterpages/PO/poList";
// import ReceivedItemList from "../masterpages/receiveditems/ReceivedItemList";
// import ItemReceivedEntry from "../masterpages/receiveditems/ItemReceivedEntry";
// import SuitabilityList from "../masterpages/suitability/SuitabilityPendingList";
// import SuitabilityEntry from "../masterpages/suitability/SuitabilityEntry";
// import BillReceiptPendingList from "../masterpages/billreceived/BillReceiptPendingList";
// import BillReceiptEntry from "../masterpages/billreceived/BillReceiptEntry";
import CosGPendingList from "../masterpages/cosG/COS_G_PendingList";
import CosGEntry from "../masterpages/cosG/COS_G_Entry";
// import AccountList from "../masterpages/accountspending/AccountsPendingList";
// import AccountEntry from "../masterpages/accountspending/AccountPendingEntry";
// import PaymentList from "../masterpages/accountspayment/PaymentPendingList";
// import PaymentEntry from "../masterpages/accountspayment/PaymentEntry";
import GeneralReports from "../masterpages/Reports/GeneralReports/GeneralReports";
import IndentDataSearch from "../search/IndentDataSearch";
import POSearch from "../search/posearch";
import POSearchDetails from "../search/POsearchdetails";
//import SignUpForm from "../masterpages/Login/SignUpForm";
import ChangePasswordForm from "../masterpages/Login/ChangePasswordForm";
import EmailForm from "../email/EmailForm";
import UnderDevelopment from "../underDevelopment";
import Error from "../error/error";
import PrivateRoutes from "./privateRoutes";
import POSearchByName from "../search/SearchbyName";

function useCOSG() {
  return (
    <>
      <Route element={<PrivateRoutes />}>
        {/* DashBoard */}
        <Route element={<ResponsiveDrawer />} path="/dashboard">
          <Route element={<PgHomeEntry />} path="" />
          {/* Indent */}
          {/* <Route element={<IndentEntry />} path="indent" />
            <Route
              element={<IndentEdit />}
              path="/dashboard/polist/indentedit"
            /> */}
          {/* PO */}
          {/* <Route element={<PoPageEntry />} path="/dashboard/polist/poentry" />
            <Route element={<POList />} path="polist" /> */}
          {/* Item Received */}
          {/* <Route element={<ReceivedItemList />} path="itemreceivedlist" />
            <Route
              element={<ItemReceivedEntry />}
              path="/dashboard/itemreceivedlist/receiveditementry"
            /> */}

          {/* Suitability */}
          {/* <Route element={<SuitabilityList />} path="suitabilitylist" />
            <Route
              element={<SuitabilityEntry />}
              path="/dashboard/suitabilitylist/suitabilityentry"
            /> */}

          {/* Bill Received */}
          {/* <Route
              element={<BillReceiptPendingList />}
              path="billpendinglist"
            />
            <Route
              element={<BillReceiptEntry />}
              path="/dashboard/billpendinglist/billentry"
            /> */}
          {/* COS/G */}
          <Route element={<CosGPendingList />} path="cosglist" />
          <Route element={<CosGEntry />} path="/dashboard/cosglist/cosgentry" />
          {/* Account */}
          {/* <Route element={<AccountList />} path="accountpendiglist" />
            <Route
              element={<AccountEntry />}
              path="/dashboard/accountpendiglist/accountentry"
            /> */}
          {/* Payment */}
          {/* <Route element={<PaymentList />} path="paymentlist" />
            <Route
              element={<PaymentEntry />}
              path="/dashboard/paymentlist/paymententry"
            /> */}

          {/* Reports */}
          <Route element={<GeneralReports />} path="adminreports" />

          {/* Search START*/}
          <Route element={<IndentDataSearch />} path="indentsearch" />
          <Route element={<POSearchByName />} path="indentsearchbyname" />
          <Route element={<POSearch />} path="posearch" />
          <Route
            element={<POSearchDetails />}
            path="/dashboard/posearch/searchpodata"
          />
          <Route
            element={<POSearchDetails />}
            path="/dashboard/indentsearch/searchpodata"
          />
          <Route
            element={<POSearchDetails />}
            path="/dashboard//indentsearchbyname/searchpodata"
          />
          {/* Search END*/}

          {/* <Route path="signup" element={<SignUpForm />} /> */}
          <Route element={<ChangePasswordForm />} path="changepassword" />
          <Route element={<EmailForm />} path="suggestions" />
          {/* Others */}
          <Route element={<UnderDevelopment />} path="underdevelopment" />
        </Route>

        {/* Error */}
        <Route element={<Error />} path="*" />
      </Route>
    </>
  );
}

export default useCOSG;
